<div class="container">
  <div class="container-title">
    <p class="title">{{ 'medicalConsultations.communication' | translate }}</p>
    <div class="action-read-container">
      <div>
        <img src="../../../../../public/assets/images/notification-red.svg" />
      </div>
      <div role="button" tabindex="0" (click)="markAllAsRead()" (keydown.enter)="markAllAsRead()" (keydown.space)="markAllAsRead(); $event.preventDefault()">
        <p class="action-read">{{ 'medicalConsultations.markRead' | translate }}</p>
      </div>
    </div>
  </div>

  @for (notification of data; track notification) {
    <div>
      <div [ngClass]="{ 'notification-toberead': notification.toRead, 'notification-read': !notification.toRead }" role="button" tabindex="0" (click)="markAsRead(notification)" (keydown.enter)="markAsRead(notification)" (keydown.space)="markAsRead(notification); $event.preventDefault()">
        <div>
          @if (notification.serviceType === 'VideoConsultReadyTelevisitVideo') {
            <img src="../../../../../public/assets/images/user-notification.svg" alt="" />
          }
          @if (notification.serviceType !== 'VideoConsultReadyTelevisitVideo') {
            <img src="../../../../../public/assets/images/mail.svg" alt="" />
          }
        </div>
        <div class="container-texts">
          <div>
            <p class="title-notification">{{ notification.title }}</p>
            <p class="notification-body">{{ notification.text }}</p>
          </div>
          @if (checkLinkValidity(notification)) {
            <div class="container-btns">
              <ds-button
                [text]="notification?.serviceType === 'TelevisitVideoConsultCompleted' ? ('medicalConsultations.evaluate' | translate) : ('medicalConsultations.enter' | translate)"
                [width]="'small'"
                (click)="openLink(notification)"
              >
              </ds-button>
            </div>
          }
        </div>
        <div role="button" tabindex="0" (click)="$event.stopPropagation(); deleteNotification(notification)" (keydown.enter)="$event.stopPropagation(); deleteNotification(notification)" (keydown.space)="$event.stopPropagation(); deleteNotification(notification); $event.preventDefault()">
          <img class="delete-icon" src="../../../../../public/assets/images/close-notification.svg" alt="close" />
        </div>
      </div>
      <span class="divider"></span>
    </div>
  }
</div>
